var map = {
	"./en": 54583,
	"./en.js": 54583,
	"./flag_en.jpg": 87437,
	"./flag_id.jpg": 91995,
	"./flag_id.png": 19267,
	"./id": 32277,
	"./id.js": 32277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9285;